import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDevices, getDevices, setCentralStateStatus, getCentralStateStatus } from '../../../state/ducks/ble/bleService';
import BleService from '../../../services/ble/BleService';


const useDeviceScanner = () => {
    
    const bleService = new BleService();

    const dispatch = useDispatch();
    const devices = useSelector(getDevices);
    const centralStateStatus = useSelector(getCentralStateStatus);
    const [scanning, setScanning] = useState(false);

    const onDeviceListUpdated = (devices) => {
        console.log('onDeviceListUpdated', devices);
        dispatch(setDevices(devices));
    };

    const onCentralStateChange = (status) => {
        console.log('onCentralStateChange', status);
        
        if (centralStateStatus != status) {
            dispatch(setCentralStateStatus(status));
        }
    }

    const getConnectedDevices = async () => {
        await bleService.getConnectedDevices(onDeviceListUpdated);
    }

    const startScan = () => {
        setScanning(true);
        bleService.startScanning(onDeviceListUpdated, onCentralStateChange);
    };

    const stopScan = () => {
        setScanning(false);
        bleService.stopScanning();
    };

    useEffect(() => {
        return () => {
            stopScan();
        };
    }, []);

    return { devices, scanning, startScan, stopScan, getConnectedDevices, centralStateStatus};
};

export default useDeviceScanner;